import React, { ReactNode } from 'react';
import TrackVisibility from 'react-on-screen';

/**
 * Blade Section.
 */
const BladeSection: React.FC<{
  backgroundColor?: string;
  children: ReactNode;
  id?: string;
  bladeType?: string;
}> = ({ backgroundColor = 'white', children, id, bladeType = 'standard' }) => {
  if (bladeType === 'teaser') {
    /**
     * Teaser section.
     */
    return (
      <TrackVisibility
        once
        partialVisibility
        tag="section"
        throttleInterval={200}
      >
        {({ isVisible }) => (
          <div
            className={`teaser-wrapper medium-vertical-margins ${
              /* istanbul ignore next */ isVisible ? '' : 'loading'
            }`}
            id={id}
          >
            <div className={`container teaser background-${backgroundColor}`}>
              <div className="container">
                <section>{children}</section>
              </div>
            </div>
          </div>
        )}
      </TrackVisibility>
    );
  }

  /**
   * Standard section.
   */
  return (
    <TrackVisibility
      once
      partialVisibility
      tag="section"
      throttleInterval={200}
    >
      {({ isVisible }) => (
        <div
          className={`blade-wrapper background-${backgroundColor} ${
            /* istanbul ignore next */ isVisible ? '' : 'loading'
          }`}
          id={id}
        >
          <div className={`container ${bladeType === 'large' ? 'large' : ''}`}>
            <section>{children}</section>
          </div>
        </div>
      )}
    </TrackVisibility>
  );
};
export default BladeSection;
